import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, inject, input, signal, viewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BbitPictureSrcDirective, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import Swiper from 'swiper';
import {
  BbitImageOverlayItem,
  BbitImageOverlayItemType,
  convertImageOverlayItems,
  IBbitImageOverlayUrlItem,
} from '../image-overlay/image-overlay.ref';
import { ImageOverlayService } from '../image-overlay/image-overlay.service';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
  imports: [NgIcon, BbitPictureSrcDirective, I18nPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ImageSliderComponent {
  private _imageOverlayService = inject(ImageOverlayService);
  readonly swiperRef = viewChild<ElementRef>('swiperRef');
  private _swiper?: Swiper;
  public enhancedItems = signal<IBbitImageOverlayUrlItem[]>([]);
  public isInitialized = signal(false);
  private _items: BbitImageOverlayItem[] = [];
  public BbitImageOverlayItemType = BbitImageOverlayItemType;

  @Input()
  set items(items: BbitImageOverlayItem[]) {
    this._items = items;
    this.enhanceItems();
  }
  readonly imageSize = input(300);
  readonly previewImageSize = input(150);
  readonly enableOverlay = input(false);
  readonly fullScreen = input(false);
  readonly hideOriginalImage = input(false);
  readonly currentIndex = input(0);
  readonly altPrefix = input<string | undefined | null>();
  private _sanitizer = inject(DomSanitizer);

  async enhanceItems(): Promise<void> {
    this.enhancedItems.set(await convertImageOverlayItems(this._items, this._sanitizer));
  }

  ngAfterViewInit(): void {
    this._swiper = this.swiperRef()?.nativeElement.swiper;
    setTimeout(() => {
      this._swiper?.slideTo(this.currentIndex(), 0);
      this.isInitialized.set(true);
    }, 100);
  }

  getStyles() {
    return JSON.stringify([':host .swiper-button-next { background: white; padding: 8px; }']);
  }

  swipeTo(index: number) {
    this._swiper?.slideTo(index);
  }

  prev() {
    this._swiper?.slidePrev();
  }

  next() {
    this._swiper?.slideNext();
  }

  show(index: number) {
    if (this.enableOverlay()) {
      this._imageOverlayService.open({
        items: this._items,
        currentIndex: index,
      });
    }
  }

  getAltText(index: number) {
    if (this.altPrefix()) {
      return `${this.altPrefix()} - Bild ${index + 1}`;
    }
    return `Bild ${index + 1}`;
  }
}
